import { normalizeQuery } from '../query/normalize-query.js';

function withCtxNormalizedQuery() {
  return async ctx => {
    // ensure query is parsed to bonnet requirements
    ctx.query = normalizeQuery(ctx.query);
  };
}

export { withCtxNormalizedQuery };
